import type { RouteLocationRaw } from 'vue-router'
import router from '@/router/index'

export function navigateTo(to: RouteLocationRaw) {
  return router.push(typeof to === 'string' ? { name: to } : to)
}

export function makeCoreUrl(path: string|string[]): string {
  let built: string

  if (typeof path === 'string') {
    built = path.replace(/^\/+/, '')
  } else {
    built = path.map(v => encodeURIComponent(v)).join('/')
  }

  return `${import.meta.env.VITE_CORE_URL}/${built}`
}